var styleDataHash = "19075d25";
const injectCss = () => {
  var css = `.PG-Fs{display:flex}[dir] .PG-Fs{margin:0}.QudRJ{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .QudRJ{margin:0;padding:0 4px}.QudRJ:hover{text-decoration:underline}.QudRJ:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.QudRJ.J-v1e{line-height:32px}[dir] .EGTuN{background:transparent;border:0}[dir] .EGTuN:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.QudRJ{max-width:160px}}}@container (width < 640px){.QudRJ{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "PG-Fs",
  "toolbarUrl": "QudRJ",
  "isMobile": "J-v1e",
  "toolbarUrlAnchor": "EGTuN"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
